import { useEffect, useState } from "react";

const secondsUntil = (target) => (target ? Math.max(0, Math.ceil((target - Date.now()) / 1000)) : 0);

// Whole seconds left until `target` (a Date.now() value), ticking once a second; 0 when there is none.
// Used for the SSN/TIN wait (docs/specs/authenticator-mfa-doc-gaps.md, part 1).
const useCountdown = (target) => {
  const [seconds, setSeconds] = useState(() => secondsUntil(target));

  useEffect(() => {
    setSeconds(secondsUntil(target));
    if (secondsUntil(target) === 0) return undefined;
    const timer = setInterval(() => {
      const left = secondsUntil(target);
      setSeconds(left);
      if (left === 0) clearInterval(timer);
    }, 1000);
    return () => clearInterval(timer);
  }, [target]);

  return seconds;
};

export default useCountdown;
